import React from 'react';
import { Box, createStyles, Theme, Typography } from '@material-ui/core';
import SlugLink from '../../../slug-link';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../../themes/main-colors';
import { BlogArticleFragment } from '../../../../__generated__/gatsby-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    panesContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      margin: '20px 0',
    },
    pane: {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.only('sm')]: {
        maxWidth: '90%',
        paddingLeft: '5%',
      },
    },
    paneDetailsContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingRight: '30px',
    },
    paneHeader: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
    paneSubHeader: {
      lineHeight: theme.typography.pxToRem(24),
      fontSize: theme.spacing(2),
    },
    paneImgContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    paneImg: {
      width: '128px',
      height: '97.22px',
      objectFit: ({ relatedPost }: Props) =>
        relatedPost?.imageFocusHorizontal || relatedPost?.imageFocusVertical
          ? 'cover'
          : 'fill',
      objectPosition: ({ relatedPost }: Props) =>
        `${relatedPost?.imageFocusHorizontal ||
          '50%'} ${relatedPost?.imageFocusVertical || '50%'}`,
    },
    narrowDivider: {
      color: colors.lightGray1,
      backgroundColor: colors.lightGray1,
      borderColor: colors.lightGray1,
      borderStyle: 'solid',
    },
  }),
);

type Props = {
  relatedPost?: BlogArticleFragment;
};

const ArticleRelatedPosts = (props: Props) => {
  const { relatedPost } = props;
  const classes = useStyles({ relatedPost });

  return (
    <>
      <Box className={classes.panesContainer}>
        <Box className={classes.pane}>
          <Box className={classes.paneDetailsContainer}>
            {relatedPost?.category?.name && (
              <Typography className={classes.paneHeader}>
                {relatedPost?.category?.name?.toLocaleUpperCase()}
              </Typography>
            )}
            <SlugLink
              slug={relatedPost?.slug}
              className={classes.paneSubHeader}
              linkText={relatedPost?.title}
            />
          </Box>
          <Box className={classes.paneImgContainer}>
            <img
              alt=""
              src={relatedPost?.heroImage?.file?.url}
              className={classes.paneImg}
            />
          </Box>
        </Box>
      </Box>
      <hr className={classes.narrowDivider} />
    </>
  );
};

export default ArticleRelatedPosts;
